import { AttachFile, Camera, CameraAlt, Delete, UploadFile } from '@mui/icons-material';
import { Button, Grow, Tooltip } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { EliminarFotoInstalacion, ObtenerImagenesInstalacion, SubirImagenesInstalacion } from '../../helpers/ActivosHelper';

export const GaleriaInstalacionesComponent = ({instalacion}) => {
    const [imagenes, setImagenes] = useState();
    const [adjuntos, setAdjuntos] = useState();
    console.log('Instalacion para obtener imagenes', instalacion);

    useEffect(() => {
        obtenerImagenesInstalacion();
    }, [instalacion])

    const obtenerImagenesInstalacion = () => {
        ObtenerImagenesInstalacion(instalacion?.key).then(datos => {
            setImagenes(datos)
            console.log('Imagenes obtenidas de instalacion', imagenes)
        });
    }

    useEffect(() => {
    }, [imagenes])
    
    
    const seleccionArchivos = (e) => {
        console.log('archivos seleccionados',e);
        setAdjuntos(e.target.files);
      }

      useEffect(() => {
        console.log('se seleccionaron archivos', adjuntos)
        const data = new FormData();
        data.append('idInstalacion',instalacion?.key);
        data.append('adjuntos',files?.length);

        files.forEach((file, i) => {
          data.append('adjuntoInstalacion'+i, file, file.name);
        });
    
        SubirImagenesInstalacion(data, instalacion).then(() => {setAdjuntos(); obtenerImagenesInstalacion()})
    
      }, [adjuntos]);

      const subirArchivos = (adjuntos, instalacion) => {
        
      }

      const eliminarFotoInstalacion = (foto) => {
        EliminarFotoInstalacion(foto).then(() => obtenerImagenesInstalacion());
      }
      
      const files = adjuntos ? [...adjuntos] : [];
  return (
    <div
        style={{
            display:'flex',
            flexDirection:'column',

        }}
    >
        <div
            style={{
                display:'flex',
                flexDirection:'row',
                paddingLeft:20
            }}
        >
             <Button
                style={{marginTop:10, 
                    borderRadius:10, backgroundColor:'#60318A'}}
                variant="contained"
                component="label"
                >
                Agregar
                <input
                  type="file"
                  accept='image/*'
                  multiple
                  inputProps={{ accept: 'image/*' }} 
                  hidden
                  onChange={(e) => {seleccionArchivos(e)}}
                  //ref={archivosRef}
                  />
                  <CameraAlt />
              </Button>              
        </div>
        <div
            style={{
                display:'flex',
                flexDirection:'row',
                minHeight:200,
                backgroundColor:'white',
                boxShadow:  '1px 2px 9px #0f0f0f',
                borderRadius:10,
                padding:20,margin:20,
                overflowX:'auto'
            }}
        >
        {
            imagenes?.map(imagen => (
        <Grow in={true} timeout={2000}>
        <div
            style={{
                margin:10,
                display:'flex',
                flexDirection:'column',
                justifyContent:'space-between'
            }}
        >
                <img
                    style={{
                        maxHeight:200,
                        borderRadius:10

                    }}
                    src={imagen}
                    loading="lazy"
                />
                <div onClick={() => eliminarFotoInstalacion(imagen)}>
                    <Delete style={{color:'red'}} />
                </div>
        </div>
        </Grow>
        ))}
        </div>
    </div>
  )
}
